/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import template from "../templates/modules/saved_searches/creator_brand_filter";

const componentName = "saved-search-brand-filter";
const selectors = {
    BRAND_LIST: ".wizard__brand-list",
    BRAND_FILTER: ".wizard__brand-filter"
};
export default baustein.register(componentName, {
    defaultOptions: {
        brands: []
    },

    template,
    init() {
        this.selectedFilters = new Map();
        const filters = Array.from(this.el.querySelectorAll(selectors.BRAND_FILTER));
        this.options.brands = [];
        filters.forEach(filter => {
            this.options.brands.push({
                name: filter.dataset["name"],
                slug: filter.dataset["slug"]
            });
        });
    },

    setupEvents(add) {
        add("submit", e => e.preventDefault());
    },
    onInsert() {
        this.setRenderContext({ brands: Array.from(this.options.brands) });
    },
    onOptionsChange() {
        this.setRenderContext({ brands: Array.from(this.options.brands) });
    }
});

